import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"
import { JobStatusSchema } from '../inputTypeSchemas/JobStatusSchema'

/////////////////////////////////////////
// CORE BACKGROUND JOB SCHEMA
/////////////////////////////////////////

export const CoreBackgroundJobSchema = z.object({
  status: JobStatusSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  userId: z.number().int().nullable(),
  emailResultsTo: z.string().nullable(),
  name: z.string(),
  jobType: z.string(),
  isTest: z.boolean(),
  stepCurrent: z.number().int(),
  stepTotal: z.number().int(),
  stepProgressMessage: z.string().nullable(),
  progressPercentage: z.number().int(),
  progressMessage: z.string().nullable(),
  recordsTotal: z.number().int(),
  recordsProcessed: z.number().int(),
  jobDetails: NullableJsonValue.optional(),
  jobError: NullableJsonValue.optional(),
  errorCount: z.number().int(),
  s3ResultsKey: z.string().nullable(),
  results: NullableJsonValue.optional(),
  createdAt: z.coerce.date(),
  startedAt: z.coerce.date().nullable(),
  endedAt: z.coerce.date().nullable(),
  cancelRequestedAt: z.coerce.date().nullable(),
})

export type CoreBackgroundJob = z.infer<typeof CoreBackgroundJobSchema>

export default CoreBackgroundJobSchema;
